import { initAccordions, initDropdowns, initModals } from 'flowbite'

class FlowbiteService {
  /**
   * We need to init Flowbite after every page navigation in the onMounted hook to make sure flowbite continues to work
   */
  public init(): void {
    initAccordions()
    initModals()
    initDropdowns()
  }
}
export default new FlowbiteService()
